import { NextRouter } from 'next/router';
import { NextPageContext } from 'next';

// 멤버십(단독 구매 상품) 판매 종료로 멤버십 페이지 접근을 홈으로 리다이렉트 (DDPS 요청, 2026-06)
// SSR(서버)이면 302, 클라이언트 전환이면 router.replace 로 깜빡임 없이 처리.
export const redirectMembershipToHome = (ctx: NextPageContext): boolean => {
  if (ctx.res) {
    ctx.res.writeHead(302, { Location: '/' });
    ctx.res.end();
    return true;
  }
  return false;
};

const routeMembership = {
  WAITING: '/error/waiting_membership',
  READY: '/error/not_membership_start',
  ACTIVE: '/community/new_post',
  OVERDUE: '/error/overdue_membership',
  EXPIRING: '/community/new_post',
  EXPIRED: '/error/not_membership',
  CANCELED: '/error/not_membership',
};

export const routeManager = (router: NextRouter, code: string) => {
  return router.push(routeMembership[code]);
};
